import {defineSlotRecipe} from '@chakra-ui/react3'

export const zoomOverlayRecipe = defineSlotRecipe({
    slots: ['content', 'body', 'actions', 'zoomFrame'],
    base: {
        content: {
            width: '100vw',
            minHeight: 0,
            height: {
                base: 'min(var(--configurator-gallery-max-height, 100dvh), calc(100vw / (var(--configurator-gallery-aspect-ratio, 1 / 1))))',
                s: '100dvh'
            },
            background:
                'linear-gradient(0deg, {colors.background.section.strong} 0%, {colors.background.section.strong} 100%), linear-gradient(180deg, #F6F3EF 0%, #E5DDD2 100%)'
        },
        body: {
            minHeight: 0,
            position: 'relative'
        },
        actions: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'spacing-8',
            position: 'absolute',
            left: 'spacing-16',
            bottom: 'spacing-16',
            padding: 0,
            zIndex: 'overlay'
        },
        zoomFrame: {
            width: '100%',
            height: '100%',
            '& > *': {
                width: '100%',
                height: '100%'
            }
        }
    }
})
